module.exports = __webpack_public_path__ + "img/firefox_webstore_icon.280a7e7a.png";